import { PageLayout, useBrowserTitle } from '@acp/core-ui';
import React, { Suspense } from 'react';
import { useExperiment } from '@acp/feature/auth';
import { Experiment } from '@acp/shared';

const ActiveNoticePage = React.lazy(() => import('../features/active-notice/page'));
const AccessIssuePage = React.lazy(() => import('../features/access-issues/page'));

export function ActiveNotice() {
    useBrowserTitle('Access Issues');
    const { isLoading, hasExperiment } = useExperiment();
    const isAccessIssuesEnabled = hasExperiment(Experiment.AgencyEntryMethod);

    return (
        <Suspense fallback={<PageLayout.Skeleton sidebar aside controls />}>
            {/* eslint-disable-next-line no-nested-ternary */}
            {isLoading ? (
                <PageLayout.Skeleton sidebar aside controls />
            ) : (
                isAccessIssuesEnabled ? <AccessIssuePage /> : <ActiveNoticePage />
            )}
        </Suspense>
    );
}
